import { NotificationV2, useToggleReadNotificationMutation } from '@/types/generated/graphql';
import { removeFromCache } from '@shared/utils/cache-helper';
import { notification } from 'antd';

export function useMarkSingleRead(showNotification: boolean = true) {
  const [markAsRead] = useToggleReadNotificationMutation({
    onError: (err) => notification.error({ message: err.message }),
    onCompleted: ({ toggleReadNotification }) => {
      if (showNotification) notification.success({ message: toggleReadNotification?.message });
    },
  });

  function markSingleReadHandler(notificationId: NotificationV2['id'], updateCache?: boolean) {
    markAsRead({
      variables: {
        notificationId,
      },
    });

    if (updateCache && notificationId) removeFromCache(notificationId, 'NotificationV2');
  }

  return {
    markSingleReadHandler,
  };
}
